// RavePilotHeader — handoff v3 design.
//
// The handoff `.topbar` calls for:
//   • Warm white→orange-tinted gradient background
//     (linear-gradient(180deg, #fff 0%, color-mix(in srgb, var(--ravepilot-orange) 3%, #fff) 100%))
//   • A thin orange hairline at the bottom plus a faint orange glow
//     a couple pixels under (decorative).
//   • Grid layout: logo + eyebrow on the left, optional center slot,
//     optional right slot. We don't use center/right on this app — the
//     entire flow has just the brand identifier — so those slots stay
//     empty and the layout still works.
//   • 26px logo height, a vertical divider before the eyebrow, and the
//     eyebrow reads "Customer testimonials" (handoff copy — was the
//     short "Testimonials" until this change).
//   • prefers-reduced-motion does nothing here; nothing animates.
//
// We keep an optional `progress` prop because it's harmless and we use
// it on the recorder flow to show upload progress at the top edge. The
// progress bar sits OUTSIDE the gradient so it doesn't fight the orange
// glow underneath.

import { brandLogo, brandName } from '../lib/brandTheme.js';

export default function RavePilotHeader({ progress = null, brand = null }) {
  return (
    <header className="vt-topbar">
      <div className="vt-topbar-left">
        <a href="/" aria-label={brandName(brand)}>
          <img
            className="vt-topbar-logo"
            src={brandLogo(brand)}
            alt={brandName(brand)}
            loading="eager"
            fetchPriority="high"
          />
        </a>
        <span className="vt-topbar-divider" aria-hidden="true" />
        <span className="vt-topbar-eyebrow">Customer testimonials</span>
      </div>
      <div className="vt-topbar-center" />
      <div className="vt-topbar-right" />
      {progress !== null && (
        <div className="vt-topbar-progress">
          <span style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} />
        </div>
      )}
    </header>
  );
}
